export default () => ({
  email: ''
});
